var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.report && _vm.hasCustomData)?_c('report-preview-custom-data',{attrs:{"report":_vm.report,"showQuickFilter":true}}):(_vm.report)?_c('report-preview-raw-data',{attrs:{"report":_vm.report,"workbook":_vm.workbook}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }